export const VIDEO_PROJECT_FIELDS = {
  PROJECT_NAME: "projectName",
  RESOLUTION: "resolution",
  ASPECT_RATIO: "aspectRatio",
  DURATION: "duration",
} as const;

export const RESOLUTION_OPTIONS = [
  {
    id: "720",
    label: "720p",
    ariaLabel: "720 pixels",
  },
  {
    id: "1080",
    label: "1080p",
    ariaLabel: "1080 pixels",
  },
];

export const ASPECT_RATIO_OPTIONS = [
  {
    id: "16:9",
    label: "16:9",
    ariaLabel: "16 BY 9 aspect ratio",
  },
  {
    id: "9:16",
    label: "9:16",
    ariaLabel: "9 by 16 aspect ratio",
  },
];

export const DURATION_OPTIONS = [
  {
    id: "4",
    label: ":04",
    ariaLabel: "4 seconds",
  },
  {
    id: "6",
    label: ":06",
    ariaLabel: "6 seconds",
  },
    {
    id: "8",
    label: ":08",
    ariaLabel: "8 seconds",
  },
];

export const VIDEO_SPEC_TITLE = "Video Specs";
export const VIDEO_RESOLUTION = "Video Resolution";
export const VIDEO_SIZE = "Video Size";
export const VIDEO_LENGTH = "Video Length";

export const VIDEO_PROJECT_NAME_ERROR = "A project name is required. Try choosing something specific to your campaign concept.";

export const resolutionFields = [
  {
    type: "radio" as const,
    name: VIDEO_PROJECT_FIELDS.ASPECT_RATIO,
    label: VIDEO_SIZE,
    ariaLabel: VIDEO_SIZE,
    useFieldset: true,
    radioGroupClassName: `bg-white border-1 rounded-lg px-6 pb-6 pt-5 mb-2`,
    optionLabelClassName: "!normal-case",
    options: ASPECT_RATIO_OPTIONS,
  },
   {
    type: "radio" as const,
    name: VIDEO_PROJECT_FIELDS.DURATION,
    label: VIDEO_LENGTH,
    ariaLabel: VIDEO_LENGTH,
    useFieldset: true,
    radioGroupClassName: `bg-white border-1 rounded-lg px-6 pb-6 pt-5 mb-2`,
    optionLabelClassName: "!normal-case",
    options: DURATION_OPTIONS,
  },
  {
    type: "radio" as const,
    name: VIDEO_PROJECT_FIELDS.RESOLUTION,
    label: VIDEO_RESOLUTION,
    ariaLabel: VIDEO_RESOLUTION,
    useFieldset: true,
    radioGroupClassName: `bg-white border-1 rounded-lg px-6 pb-6 pt-5 mb-2`,
    optionLabelClassName: "!normal-case",
    options: RESOLUTION_OPTIONS,
  },
];
